import React, { useRef } from 'react';

import { CustomTooltip } from '..';
import { RenderComponentProps } from '../DataTable/types';
import useStyles from './styles';

const CustomArrayTooltip: React.FC<RenderComponentProps> = ({ value }) => {
  const classes = useStyles();
  const tooltipRef = useRef(null);

  const TooltipTitle = (
    <div className={classes.tooltipContainer}>
      {value?.map((item: any) => (
        <span key={item.id} className={classes.label}>
          {item.name}
        </span>
      ))}
    </div>
  );

  return (
    <CustomTooltip
      title={`Avaliações associadas (${value?.length})`}
      ref={tooltipRef}
      labelValue={TooltipTitle}
      showCircle={false}
      maxWidth={200}
      minWidth={200}
    >
      <span className={classes.label}>{`(${value?.length}) ${
        value && value[0].name
      }`}</span>
    </CustomTooltip>
  );
};

export default CustomArrayTooltip;
